import React from 'react'
import { Link } from 'react-router-dom'
import AddDiwaniya from './AddDiwaniya'
import Constant from '../../Constant'
class DiwaniyaAddTab extends React.Component {
  state = {
    language_data: [],
  }

  componentDidMount() {
    if (
      this.props.match.params.diwaniya_Id !== undefined &&
      this.props.match.params.diwaniya_Id !== null &&
      this.props.match.params.diwaniya_Id !== 0 &&
      this.props.match.params.diwaniya_Id !== ''
    ) {
      this.setState({ diwaniya_Id: this.props.match.params.diwaniya_Id })
    }
    this.getLanguageList()
  }
  getLanguageList = () => {
    var language_data = Constant.getLanguageList()
    this.setState({
      language_data: language_data,
      language_id: language_data[0].id,
      isLoading: false,
    })
  }
  handleLanguage = (language_id) => {
    this.setState({ language_id: language_id })
  }

  render() {
    return (
      <div className="main-body">
        <div className="page-wrapper">
          <div className="page-header">
            <div className="row align-items-end">
              <div className="col-lg-8">
                <div className="page-header-title">
                  <div className="d-inline">
                    <h4>
                      {this.props?.match?.params?.boatType} Diwaniya{' '}
                      {this.props.match.params.diwaniya_Id ? 'Edit' : 'Add'}
                    </h4>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="page-header-breadcrumb">
                  <ul className="breadcrumb-title">
                    <li className="breadcrumb-item">
                      <Link to="/">
                        <i className="feather icon-home"></i>{' '}
                      </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link
                        to={`/boatsmaster/${this.props.match.params.boatType}/${this.props.match.params.boatId}/diwaniya-lists`}
                      >
                        {this.props.match.params.boatType} Diwaniya List
                      </Link>
                    </li>
                    <li className="breadcrumb-item active">
                      {this.props.match.params.boatType ? 'Edit' : 'Add'} Diwaniya add
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-border-default">
                  <div className="card-block">
                    <div className="tab-content tabs">
                      <div
                        className="tab-pane  active"
                        id={'Products_add_' + this.state.language_id}
                        role="tabpanel"
                        aria-labelledby=""
                      >
                        {this.state.diwaniya_Id !== undefined &&
                        this.state.diwaniya_Id !== null &&
                        this.state.diwaniya_Id !== 0 &&
                        this.state.diwaniya_Id !== '' ? (
                          <AddDiwaniya
                            goBack={this.props.history.goBack}
                            boatType={this.props.match.params.boatType}
                            boatId={this.props.match.params.boatId}
                            diwaniya_Id={this.state.diwaniya_Id}
                          />
                        ) : (
                          <AddDiwaniya
                            language_id={this.state.language_id}
                            boatId={this.props.match.params.boatId}
                            boatType={this.props.match.params.boatType}
                            goBack={this.props.history.goBack}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default DiwaniyaAddTab
